import { useEffect, useState, useRef } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { handleLogoutPharmacy } from '../services/actions/main/logout';
import useCustomNavigate from './useCustomNavigation';

export const INACTIVITY_LOGOUT_ACTIVITY_EVENT = 'oatrx-inactivity-logout-activity';

const useInactivityLogout = (isAuthenticated, timeoutMinutes = 15) => {

	const navigate = useCustomNavigate();
	const [logoutLoading, setLogoutLoading] = useState(false);

	// 🔐 Prevent multiple logout calls
	const hasLoggedOutRef = useRef(false);
	const isDevelopment = process.env.NODE_ENV === 'development';

	const onIdle = () => {
		// ❌ Do nothing in development
		if (isDevelopment) return;

		// ❌ Already logged out or logout in progress
		if (!isAuthenticated || hasLoggedOutRef.current) return;

		hasLoggedOutRef.current = true;
		handleLogoutPharmacy(setLogoutLoading, navigate);
	};

	const idleTimer = useIdleTimer({
		enabled: isAuthenticated && !hasLoggedOutRef.current,
		timeout: timeoutMinutes * 60 * 1000,
		onIdle,
		debounce: 500,
		crossTab: true,
		syncTimers: true,
		leaderElection: true
	});

	useEffect(() => {
		if (!isAuthenticated || hasLoggedOutRef.current || typeof window === 'undefined') {
			return undefined;
		}

		const handleSystemActivity = () => {
			if (!hasLoggedOutRef.current) {
				idleTimer.reset();
			}
		};

		window.addEventListener(INACTIVITY_LOGOUT_ACTIVITY_EVENT, handleSystemActivity);

		return () => {
			window.removeEventListener(INACTIVITY_LOGOUT_ACTIVITY_EVENT, handleSystemActivity);
		};
	}, [idleTimer, isAuthenticated]);

	return { logoutLoading };
};

export default useInactivityLogout;
